import { Link } from "react-router-dom";

const faqGroups = [
  {
    title: "关于书库",
    icon: "ri-book-2-line",
    items: [
      { q: "天堂漫画全库的漫画会持续更新吗？", a: "会的。天堂漫画完整书库持续更新，热门连载作品每日同步最新章节，冷门完结作品也会持续补全，确保全站漫画海量资源保持新鲜与完整。" },
      { q: "全库一共收录了多少部漫画？", a: "目前天堂漫画全库已收录 8.6 万余部作品，覆盖 40+ 类目，热门连载与冷门完结均有收录，且持续不断扩充。" },
      { q: "为什么有些作品找不到？", a: "个别作品可能因版权或来源调整暂时下架。你可以通过意见反馈告诉我们，我们会尽力协调资源，尽快补全。" },
    ],
  },
  {
    title: "阅读与功能",
    icon: "ri-book-read-line",
    items: [
      { q: "在手机上能正常阅读吗？", a: "完全可以。天堂漫画采用响应式设计，手机、平板、电脑都能流畅阅读，页面会自适应屏幕尺寸，随时随地追漫画。" },
      { q: "如何快速找到自己想看的漫画？", a: "你可以使用顶部搜索直接输入作品名或作者，也可以进入全站分类页按类目逐层筛选，轻松定位目标作品。" },
      { q: "收藏的作品去哪里查看？", a: "登录账号后，在作品页面点击「加入书架」即可收藏，可在个人书架中集中管理所有追更作品，方便随时续读。" },
    ],
  },
  {
    title: "账号与反馈",
    icon: "ri-user-3-line",
    items: [
      { q: "如何联系天堂漫画团队？", a: "你可以通过「联系我们」页面填写反馈表单，或发送邮件至 service@tiantangmh.example，我们会尽快回复。" },
      { q: "我的账号会保存阅读记录吗？", a: "登录后，阅读历史、收藏书架等数据会与账号绑定保存，方便你在不同设备上无缝续读。" },
      { q: "遇到阅读问题或资源错误怎么办？", a: "请通过意见反馈告诉我们具体作品与问题描述，我们的团队会及时核查并修复，为你提供更好的体验。" },
    ],
  },
];

const allFaqs = faqGroups.flatMap((g) => g.items);

export default function Faq() {
  return (
    <div className="pt-16">
      <div className="border-b border-background-200 bg-background-100">
        <div className="mx-auto max-w-7xl px-4 py-4 md:px-6">
          <nav className="flex flex-wrap items-center gap-1.5 text-sm text-foreground-600" aria-label="面包屑导航">
            <Link to="/" className="transition-colors hover:text-primary-600">首页</Link>
            <i className="ri-arrow-right-s-line text-foreground-400"></i>
            <span className="font-medium text-foreground-950">常见问题</span>
          </nav>
        </div>
      </div>

      <div className="mx-auto max-w-4xl px-4 py-12 md:px-6 md:py-16">
        <div className="text-center">
          <span className="flex items-center justify-center gap-2 text-sm font-medium text-primary-600">
            <i className="ri-question-line"></i> 帮助中心
          </span>
          <h1 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-4xl">天堂漫画常见问题</h1>
          <p className="mx-auto mt-3 max-w-2xl text-sm text-foreground-600 md:text-base">
            关于全库书库、阅读功能与账号反馈的常见疑问，这里一次性为你解答。若仍有问题，欢迎联系我们。
          </p>
        </div>

        <div className="mt-12 space-y-12">
          {faqGroups.map((g) => (
            <section key={g.title}>
              <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950">
                <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-100 text-lg text-primary-600">
                  <i className={g.icon}></i>
                </span>
                {g.title}
              </h2>
              <div className="mt-4 space-y-3">
                {g.items.map((f) => (
                  <details key={f.q} className="group rounded-xl border border-background-200 bg-background-100 p-5">
                    <summary className="flex cursor-pointer list-none items-center justify-between gap-3 font-medium text-foreground-950 [&::-webkit-details-marker]:hidden">
                      <span>{f.q}</span>
                      <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-200 text-foreground-600 transition-transform group-open:rotate-180">
                        <i className="ri-arrow-down-s-line"></i>
                      </span>
                    </summary>
                    <p className="mt-3 text-sm leading-relaxed text-foreground-600">{f.a}</p>
                  </details>
                ))}
              </div>
            </section>
          ))}
        </div>

        <section className="mt-12 rounded-3xl bg-background-100 p-8 text-center">
          <h2 className="font-heading text-lg font-bold text-foreground-950">没找到你想要的答案？</h2>
          <p className="mt-2 text-sm text-foreground-600">随时通过反馈告诉我们，我们会第一时间为你解答。</p>
          <Link to="/contact" className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600">
            前往联系我们 <i className="ri-arrow-right-line"></i>
          </Link>
        </section>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: allFaqs.map((f) => ({
              "@type": "Question",
              name: f.q,
              acceptedAnswer: { "@type": "Answer", text: f.a },
            })),
          }),
        }}
      />
    </div>
  );
}